import { render, staticRenderFns } from "./BqDataViewer.vue?vue&type=template&id=115b3127&scoped=true&"
import script from "./BqDataViewer.vue?vue&type=script&lang=js&"
export * from "./BqDataViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b3127",
  null
  
)

export default component.exports